module.exports = __webpack_public_path__ + "static/bsas012-7f2d723348c9c1e44ee6e9a934dc8354.jpg";